













































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { ChainModule } from '@/store/modules/chain.module'
import ScrollView from '@/components/ScrollView.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { EBillingHistoryType, IBillingHistory } from '@zunta/configurations'
import ModalV2 from '@/components/modals/ModalV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'

@Component({
  components: {
    TextareaV2,
    ModalV2,
    ScrollView,
    DateTimeLabel
  },
  props: {
    invoiceId: {
      type: Number,
      required: true
    }
  }
})
export default class BillingHistoryModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  historyText: string = ''

  isLoading: boolean = false

  get history () {
    return this.$store.state.chain.billingHistory
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.chainModuleInstance.fetchBillingHistory(this.$props.invoiceId)
    } finally {
      this.isLoading = false
    }
  }

  getHistoryLabel (item: IBillingHistory) {
    switch (item.type) {
      case EBillingHistoryType.CREATED:
        return `<span>Invoice was generated</span>`
      case EBillingHistoryType.RECREATED:
        return `<span>Invoice was updated</span>`
      case EBillingHistoryType.BILLED:
        return `
          <div>
            <span>A payment was made for this invoice</span></br>
          </div>
          `
      case EBillingHistoryType.EMAILED:
        return `
          <div>
            <span>Invoices was Emailed To:</span><span class="email">${item.emails.join(', ')}</span>
          </div>
          `
      case EBillingHistoryType.STATUS_CHANGE:
        return `<span>Status was changed</span>`
      case EBillingHistoryType.EMAIL_REJECTED:
      case EBillingHistoryType.CUSTOM:
        return `<span>${(item.text || '').replace(/\n/g, '<br/>')}</span>`
      default:
        return '<span>Unkown Action</span>'
    }
  }

  async addHistory () {
    if (!this.historyText || !this.historyText.length) {
      return
    }

    try {
      this.isLoading = true
      await this.chainModuleInstance.addBillingHistory({
        text: this.historyText,
        invoice: this.$props.invoiceId,
        type: EBillingHistoryType.CUSTOM
      })
      await this.chainModuleInstance.fetchBillingHistory(this.$props.invoiceId)
      this.historyText = ''
    } finally {
      this.isLoading = false
    }
  }
}
